import React from 'react';
import { getComponentContent } from '../../helpers.js';
const NotFoundPage = ({history}) => {

  const goHome = () => {
    history.push('/');
  }

  const content = getComponentContent('NotFoundPage');

  return (
    <div className="ssc__page page--not-found ssc__page--mounted">
      <div className="ssc__page__inner">
        <h1>{content.title}</h1>
        <div className="ssc__link" onClick={goHome}>{content.linkText}</div>
      </div>
    </div>
  );
  
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/components/NotFoundPage/NotFoundPage.js